"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungList = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const VerpackungFactory_1 = require("./VerpackungFactory");
/**
 * The `VerpackungList` manages a list of `Palette` or `Trommel`objects
 */
class VerpackungList extends ArticleList_1.ArticleList {
    static fromScratch() {
        return new VerpackungList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new VerpackungList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new VerpackungList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new VerpackungList();
        list.fromArray(arr);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(VerpackungFactory_1.VerpackungFactory.fromJson(itemJson, cloneStrategy));
        }
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        this.items = model.map((m) => VerpackungFactory_1.VerpackungFactory.fromModel(m));
        this.model = model;
        this.emitChange();
    }
    toJson() {
        const json = [];
        for (const item of this.items) {
            json.push(item.toJson());
        }
        return json;
    }
    toModel() {
        return this.model;
    }
    clone() {
        return VerpackungList.fromArray(this.items.map((i) => i.clone()));
    }
    /**
     * Retrieves the cumulated weight of all Verpackungen in the list.
     */
    getCumulatedWeight() {
        return echain_shared_quantities_1.Weight.kg(this.items.reduce((cumulatedWeight, verpackung) => cumulatedWeight + (verpackung.gewicht ? verpackung.gewicht.kg : 0), 0));
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * Returns a new list with VerpackungList filtered by set ArtNrCountry.
     */
    filterByArtNrCountry(artNrCountry) {
        return VerpackungList.fromArray(this.items.filter((article) => article.localizedArtNr && article.localizedArtNr[artNrCountry]));
    }
}
exports.VerpackungList = VerpackungList;
//# sourceMappingURL=VerpackungList.js.map